import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../Const/Url';
import { showToast } from '../../utils/ToastHelper';
import Loader from '../CustomCommons/Loader';
import EditIcon from '../CustomCommons/EditIcon';
import DeleteIcon from '../CustomCommons/DeleteIcon';
import swal from 'sweetalert';
import PreviousIcon from '../CustomCommons/PreviousIcon';
import NextIcon from '../CustomCommons/NextIcon';
import { logout_func2 } from '../Const/logoutCommon';
import * as path from '../Routes/RoutePaths';
import plus from '../../assets/Icon/plus.svg';

// Search keys for filtering
const keys = ['id', 'name', 'description'];

const NewRoleList = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [roleList, setRoleList] = useState([]);
  const [filteredRoleList, setFilteredRoleList] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [query, setQuery] = useState('');
  const limit = 20;
  const pageCount = Math.ceil(totalData / limit);

  // Fetch roles from API
  const apiFunction = (url) => {
    setIsLoading(true);
    axios
      .get(url)
      .then((res) => {
        if (res.data.status === 'success' && res.data.data) {
          const results = res.data.data.results || [];
          setRoleList(results);
          setFilteredRoleList(results);
          setTotalData(res.data.data.count || 0);
          setNextUrl(res.data.data.next);
          setPrevUrl(res.data.data.previous);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        const message = err.response?.data?.message || err.message || 'Failed to fetch roles';
        showToast('error', message);
        console.error('Error fetching roles:', err);
        
        if (
          message === 'Invalid token.' ||
          err.response?.data?.code === 401
        ) {
          logout_func2(() => {}, history);
        }
      });
  };

  const getRoleList = () => {
    const url = `${BASE_URL}api/v1/auth/v2/roles/?limit=${limit}`;
    apiFunction(url);
  };

  useEffect(() => {
    getRoleList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePaginationPrevious = () => {
    if (prevUrl) {
      apiFunction(prevUrl);
      setPageNumber((prev) => {
        if (prev > 1) {
          return prev - 1;
        } else {
          return prev;
        }
      });
    }
  };

  const handlePaginationNext = () => {
    if (nextUrl) {
      apiFunction(nextUrl);
      setPageNumber((prev) => prev + 1);
    }
  };

  const handleChangeCurrentPage = (val) => {
    setPageNumber(val);
  };

  // Delete role
  const deleteRole = (id) => {
    swal({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this Data',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const url = `${BASE_URL}api/v1/auth/v2/roles/${id}/`;
        axios
          .delete(url)
          .then(() => {
            showToast('success', 'Role Deleted Successfully');
            // Refresh the list - maintain current page if possible
            const offset = (pageNumber - 1) * limit;
            const currentUrl = `${BASE_URL}api/v1/auth/v2/roles/?limit=${limit}&offset=${offset}`;
            apiFunction(currentUrl);
          })
          .catch((err) => {
            const errorMsg = err.response?.data?.message || err.message || 'Failed to delete role';
            showToast('error', errorMsg);
            console.error('Error deleting role:', err);
          });
        swal('Your data has been deleted!', {
          icon: 'success',
        });
      } else {
        swal('Your data is safe!');
      }
    });
  };

  // Handle edit - navigate to edit page (you'll need to create this route)
  const handleEdit = (roleId) => {
    // Navigate to edit page - adjust the route as needed
    history.push(`/user/edit-role/${roleId}`);
  };

  // Search functionality
  useEffect(() => {
    if (query) {
      const filtered = roleList.filter((role) =>
        keys.some((key) =>
          role[key]?.toString()?.toLowerCase()?.includes(query.toLowerCase())
        )
      );
      setFilteredRoleList(filtered);
    } else {
      setFilteredRoleList(roleList);
    }
  }, [query, roleList]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <div className="categorey-parent my-4" style={{ height: '100%' }}>
        <div className="cotagorey-head mb-4">
          <div className="d-flex align-align-items-baseline">
            <div>
              <h3>Role List</h3>
              <input
                style={{ color: 'black' }}
                type="text"
                className="filter-input"
                placeholder="Search here"
                value={query}
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="filter_div">
            <div
              className="button-div"
              onClick={() => history.push(path.add_new_role)}
            >
              <img src={plus} alt="" />
              <span>Add Role</span>
            </div>
          </div>
        </div>

        {/* Role Table */}
        <div style={{ overflowX: 'auto' }} className="table-responsive">
          <table className="table_my">
            <thead
              className="bg-dark text-white head-row"
              style={{ height: '50px' }}
            >
              <tr className="">
                <th
                  className="ms-3"
                  style={{
                    fontSize: '16px',
                    fontWeight: 'normal',
                    borderTopLeftRadius: '4px',
                  }}
                >
                  <p className="ms-3 mt-3">ID</p>
                </th>
                <th style={{ fontSize: '16px', fontWeight: 'normal' }}>
                  Name
                </th>
                <th style={{ fontSize: '16px', fontWeight: 'normal' }}>
                  Description
                </th>
                <th style={{ fontSize: '16px', fontWeight: 'normal' }}>
                  Status
                </th>
                <th
                  style={{
                    fontSize: '16px',
                    fontWeight: 'normal',
                    borderTopRightRadius: '4px',
                    textAlign: 'center',
                  }}
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="tb">
              {filteredRoleList.length > 0 ? (
                filteredRoleList.map((role) => (
                  <tr key={role.id} className="table-row">
                    <td>
                      <p className="ms-3 mt-3">{role.id}</p>
                    </td>
                    <td>
                      <span
                        style={{
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        {role.name}
                      </span>
                    </td>
                    <td>
                      <span style={{ fontSize: '14px' }}>
                        {role.description || 'N/A'}
                      </span>
                    </td>
                    <td className="">
                      <button
                        className={`status ${role?.is_active ? 'c1' : 'c2'}`}
                      >
                        {role?.is_active ? 'Active' : 'Inactive'}
                      </button>
                    </td>
                    <td>
                      <div className="d-flex justify-content-center gap-3">
                        <div
                          className="edit-del green"
                          onClick={() => handleEdit(role.id)}
                        >
                          <EditIcon />
                        </div>
                        <div
                          className="edit-del red"
                          onClick={() => deleteRole(role.id)}
                        >
                          <DeleteIcon />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">
                    <div className="not_found d-flex justify-content-center align-items-center py-4">
                      <h4 className="my-4">No Data Found</h4>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalData > 0 && (
          <div className="row pag" style={{ marginTop: '30px' }}>
            <div className="col-6 col-md-5">
              <p
                className="inter"
                style={{ color: '#AEAEB2', fontSize: '16px' }}
              >
                Total Entries:{' '}
                <span style={{ color: 'black', fontSize: '14px' }}>
                  {totalData}
                </span>
                <span className="ms-2"></span>
                Total Page:{' '}
                <span style={{ color: 'black', fontSize: '14px' }}>
                  {Math.ceil(totalData / limit)}
                </span>
              </p>
            </div>

            <div className="col-12 col-md-6 d-flex paggination-button">
              <>
                <div className="row lead_pagination bg-transparent">
                  <div className="col-12 col-lg-6 d-flex justify-content-lg-end justify-content-md-end  col-md-6 col-sm-6  col-xs-12 pagination_container">
                    <nav aria-label="...">
                      <ul className="pagination pagination-sm">
                        {!isLoading ? (
                          <li className="page-item ">
                            {prevUrl !== null ? (
                              <Link
                                onClick={handlePaginationPrevious}
                                className={` ${
                                  prevUrl === null ? 'disabled' : ''
                                } page-link pagination_texts  pagination_btn font_size_for_small py-1 mt-1 me-3 a`}
                                to="#"
                                tabIndex="-1"
                              >
                                <PreviousIcon />
                              </Link>
                            ) : (
                              <Link
                                onClick={() =>
                                  showToast('success', 'You are on first page')
                                }
                                className={` ${
                                  prevUrl === null ? 'disabled' : ''
                                } page-link pagination_texts pagination_btn font_size_for_small me-3 py-1 mt-1 a`}
                                to="#"
                                tabIndex="-1"
                              >
                                <PreviousIcon />
                              </Link>
                            )}
                          </li>
                        ) : (
                          <li className="page-item ">
                            <Link
                              className={` ${
                                prevUrl === null ? 'disabled' : ''
                              } page-link pagination_texts pagination_btn font_size_for_small me-3 py-1 mt-1 a`}
                              to="#"
                              tabIndex="-1"
                            >
                              <PreviousIcon />
                            </Link>
                          </li>
                        )}

                        {[...Array(pageCount === null ? 1 : pageCount)].map(
                          (elem, index) => (
                            <li
                              key={index}
                              className="page-item"
                              style={{
                                display: `${
                                  index + 1 !== pageNumber ? 'none' : 'block'
                                }`,
                              }}
                            >
                              <Link
                                onClick={() =>
                                  handleChangeCurrentPage(index + 1)
                                }
                                className={`${
                                  index + 1 === pageNumber
                                    ? 'paginationActive'
                                    : ''
                                } page-link lead_page_link lead_page_link1 font_size_for_small pagination_texts px-2 text-dark`}
                                to="#"
                              >
                                <span className="px-1 py-1">{pageNumber}</span>
                              </Link>
                            </li>
                          )
                        )}
                        {!isLoading ? (
                          <li className="page-item">
                            {nextUrl !== null ? (
                              <Link
                                onClick={handlePaginationNext}
                                className={`${
                                  nextUrl === null ? 'disabled' : ''
                                } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                                to="#"
                              >
                                <NextIcon />{' '}
                              </Link>
                            ) : (
                              <Link
                                onClick={() =>
                                  showToast('success', 'You are on last page')
                                }
                                className={`${
                                  nextUrl === null ? 'disabled' : ''
                                } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                                to="#"
                              >
                                <NextIcon />
                              </Link>
                            )}
                          </li>
                        ) : (
                          <li className="page-item">
                            <Link
                              className={`${
                                nextUrl === null ? 'disabled' : ''
                              } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                              to="#"
                            >
                              <NextIcon />
                            </Link>
                          </li>
                        )}
                      </ul>
                    </nav>
                  </div>
                </div>
              </>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewRoleList;
